module.exports = __webpack_public_path__ + "static/parade-2020-house24-4c366e0e2223a0d1a55de89d3cd67dc7.jpg";